document.addEventListener('DOMContentLoaded', () => {
    const messages = document.querySelectorAll('.announcement-message');
    let currentMessageIndex = 0;

    function showNextMessage() {
        // Hide the current message
        messages[currentMessageIndex].classList.remove('active');

        // Increment index, reset if at the end
        currentMessageIndex = (currentMessageIndex + 1) % messages.length;

        // Show the next message
        messages[currentMessageIndex].classList.add('active');
    }

    // Initially show the first message
    messages[currentMessageIndex].classList.add('active');

    // Set interval for message rotation (e.g., every 5 seconds)
    setInterval(showNextMessage, 5000); // 5000 milliseconds = 5 seconds
});